import { lazy } from 'react';
import { authRoles } from 'src/app/auth';

const IbusApp = lazy(() => import('./IbusApp'));

const IbusNavConfig = {
    settings: {
        layout: {},
    },
    auth: authRoles.user,
    routes: [
        {
            path: 'apps/ibus/configurations',
            element: <IbusApp />,
        }
    ],
};

export default IbusNavConfig;
